// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"page-header_wrapper__b4d4d","title":"page-header_title__NchNe","scrollButton":"page-header_scrollButton__EPx89","bounce":"page-header_bounce__LIXT0"};